import React, { useEffect, useState } from 'react'
import { Box, Button, CardContent, CardHeader, Grid, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import ApiService from "../../services/categoryManagementApi";
import errorHandler from '../../utils/errorHandler';
import CardLayout from '../../layouts/CardLayout';
import CustomLoader from '../../components/customLoader';
import SaveCancelButton from '../../components/Buttons/SaveCancelButton';
const { NotificatiopnApi } = ApiService;


const NotificationEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams()
    const [loading, setLoading] = useState(false)


    const formik = useFormik({
        initialValues: {
            id: id || "",
            notificationType: "",
            title: "",
            titleKh: "",
            contentKh: "", 
            content: ""
        },
        validationSchema: Yup.object({
            notificationType: Yup.string().required("Notification type is required").trim(),
            title: Yup.string().required("Title is required").trim(),
            titleKh: Yup.string().required("Khmer title is required").trim(),
            content: Yup.string().required("Content is required").trim(),
            contentKh: Yup.string().required("Khmer content is required").trim(),
        }),
        onSubmit: (values, { setSubmitting }) => {
            handleSumbit(values, setSubmitting)
        }
    });
    const { errors, touched, getFieldProps, isSubmitting } = formik;


    const getData = async () => {
        try {
            setLoading(true)
            let res = await NotificatiopnApi.getOneNotificationTemplate(id)
            formik.setFieldValue("id", id)
            formik.setFieldValue("notificationType", res?.data?.data?.notificationType)
            formik.setFieldValue("title", res?.data?.data?.title)
            formik.setFieldValue("titleKh", res?.data?.data?.titleKh)
            formik.setFieldValue("content", res?.data?.data?.content)
            formik.setFieldValue("contentKh", res?.data?.data?.contentKh)
        } catch (error) {
            errorHandler(error)
        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        if (id) {
            getData()
        }
    }, [id])


    const handleSumbit = async (values, setSubmitting) => {
        try {
            setSubmitting(true)
            const res = id ? await NotificatiopnApi.updateNotificationTemplate(values)
                           : await NotificatiopnApi.addNotificationTemplate(values)
            toast.success(res?.data?.message)
            navigate("/notification-management")
        } catch (error) {
            errorHandler(error)
        }
        finally {
            setSubmitting(false)
        }
    }



    return (
        <Box>
            <CardLayout>
                <CardHeader title={id ? "Edit Notification" : "Add Notification"} />
                <CardContent>
                    {loading
                        ? <CustomLoader />
                        :
                        <FormikProvider value={formik}>
                            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                                <Grid item container spacing={3} direction={"column"} xs={12} >

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Notification Type"
                                            required
                                            error={Boolean(touched.notificationType && errors.notificationType)}
                                            helperText={touched.notificationType && errors.notificationType}
                                            {...getFieldProps("notificationType")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Title (English)"
                                            required
                                            error={Boolean(touched.title && errors.title)}
                                            helperText={touched.title && errors.title}
                                            {...getFieldProps("title")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Title (Khmer)"
                                            required
                                            error={Boolean(touched.titleKh || errors.titleKh)}
                                            helperText={touched.titleKh ||  errors.titleKh}
                                            {...getFieldProps("titleKh")}
                                        />
                                    </Grid>
                                    <Grid item sx={12}>
                                        <TextField
                                            fullWidth
                                            label="Content (English)"
                                            multiline
                                            rows={10}
                                            required
                                            error={Boolean(touched.content && errors.content)}
                                            helperText={touched.content && errors.content}
                                            {...getFieldProps("content")}
                                        />
                                    </Grid>
                                    <Grid item sx={12}>
                                        <TextField
                                            fullWidth
                                            label="Content (Khmer)"
                                            multiline
                                            rows={10}
                                            required
                                            error={Boolean(touched.contentKh || errors.contentKh)}
                                            helperText={touched.contentKh || errors.contentKh}
                                            {...getFieldProps("contentKh")}
                                        />
                                    </Grid>
                                </Grid>
                                <SaveCancelButton isSubmitting={isSubmitting} id={id} />
                            </Form>
                        </FormikProvider>
                    }
                </CardContent>
            </CardLayout>
        </Box>
    )
}

export default NotificationEdit